import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  GraduationCap,
  Users,
  Trophy,
  BookOpen,
  Calendar,
  ArrowRight,
  CheckCircle2,
} from "lucide-react";

const AboutUs = () => {
  const [activeTab, setActiveTab] = useState("mission");

  return (
    <div>
      <Helmet>
        <title>About SSS Achievers | Best Coaching Center in Ghazipur UP</title>
        <meta name="description" content="Learn about SSS Achievers – Ghazipur's trusted coaching institute. Founded by Saumya Rai, we have empowered 340+ students with expert faculty, 95% success rate and quality education since 2025." />
        <link rel="canonical" href="https://www.sssachievers.com/about" />
        <meta property="og:title" content="About SSS Achievers | Best Coaching Center in Ghazipur UP" />
        <meta property="og:description" content="Learn about SSS Achievers – Ghazipur's trusted coaching institute with 340+ students, 35+ educators and 95% success rate." />
        <meta property="og:url" content="https://www.sssachievers.com/about" />
      </Helmet>
      <div>
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row items-center gap-12">
              <div className="md:w-1/2">
                <div className="relative">
                  <div className="absolute overflow-hidden -top-4 -left-4 w-full h-full border-2 border-[#0097b2] rounded-xl"></div>
                  <img
                    src="./images/website about-us.png"
                    alt="SSS Achievers Campus"
                    className="w-full h-auto rounded-xl relative z-10 object-cover max-h-[400px] sm:max-h-[480px] md:max-h-[560px]"
                  />
                  <div className="absolute -bottom-6 -right-6 bg-[#0097b2] text-white p-4 rounded-lg shadow-lg z-20">
                    <p className="font-bold">Est. 2025</p>
                  </div>
                </div>
              </div>
              <div className="md:w-1/2">
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-800">
                  Our Story
                </h2>
                <div className="w-20 h-1 bg-[#0097b2] mb-8"></div>
                <p className="text-lg text-gray-600 mb-6">
                  SSS Achievers was founded with a vision to transform the
                  educational landscape in Ghazipur. What started as a small
                  tutoring center has now grown into the region's premier
                  coaching institute.
                </p>
                <p className="text-lg text-gray-600 mb-8">
                  Our journey has been defined by our commitment to excellence,
                  innovation in teaching methodologies, and a student-centric
                  approach that has helped hundreds of students achieve their
                  academic and career goals.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex items-start">
                    <div className="mr-4 bg-[#0097b2]/10 p-3 rounded-full">
                      <Trophy className="h-6 w-6 text-[#0097b2]" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-800 mb-2">
                        Excellence
                      </h3>
                      <p className="text-gray-600">
                        Committed to the highest standards in education
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="mr-4 bg-[#0097b2]/10 p-3 rounded-full">
                      <Users className="h-6 w-6 text-[#0097b2]" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-800 mb-2">
                        Community
                      </h3>
                      <p className="text-gray-600">
                        Building a supportive learning environment
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="mr-4 bg-[#0097b2]/10 p-3 rounded-full">
                      <BookOpen className="h-6 w-6 text-[#0097b2]" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-800 mb-2">
                        Innovation
                      </h3>
                      <p className="text-gray-600">
                        Embracing new teaching methodologies
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="mr-4 bg-[#0097b2]/10 p-3 rounded-full">
                      <Calendar className="h-6 w-6 text-[#0097b2]" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-800 mb-2">
                        Consistency
                      </h3>
                      <p className="text-gray-600">
                        Delivering results year after year
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0097b2]/10 to-[#0097b2]/20">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-center mb-8">
            <div className="inline-flex rounded-lg bg-white p-1 shadow-md">
              <button
                onClick={() => setActiveTab("mission")}
                className={`px-6 py-3 rounded text-sm font-medium transition-all ${
                  activeTab === "mission"
                    ? "bg-[#0097b2] text-white"
                    : "text-gray-700 hover:bg-gray-100"
                }`}
              >
                Our Mission
              </button>
              <button
                onClick={() => setActiveTab("vision")}
                className={`px-6 py-3 rounded text-sm font-medium transition-all ${
                  activeTab === "vision"
                    ? "bg-[#0097b2] text-white"
                    : "text-gray-700 hover:bg-gray-100"
                }`}
              >
                Our Vision
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="bg-white overflow-hidden">
            {activeTab === "mission" ? (
              <div className="p-8 sm:p-10 lg:p-12">
                <div className="flex flex-col md:flex-row items-center gap-8">
                  <div className="md:w-1/2">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6">
                      <span className="text-[#0097b2]">Empowering</span> Through
                      Education
                    </h3>
                    <p className="text-lg text-gray-600 mb-6">
                      Our mission is to empower students to excel academically
                      and secure their future in prestigious careers through
                      comprehensive preparation for competitive exams and strong
                      academic foundations.
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="bg-[#0097b2]/10 p-4 rounded-lg">
                        <h4 className="font-medium text-[#0097b2] mb-2">
                          Accessibility
                        </h4>
                        <p className="text-sm text-gray-700">
                          Provide quality education accessible to all
                        </p>
                      </div>
                      <div className="bg-[#0097b2]/10 p-4 rounded-lg">
                        <h4 className="font-medium text-[#0097b2] mb-2">
                          Critical Thinking
                        </h4>
                        <p className="text-sm text-gray-700">
                          Develop critical thinking and problem-solving skills
                        </p>
                      </div>
                      <div className="bg-[#0097b2]/10 p-4 rounded-lg col-span-1 sm:col-span-2">
                        <h4 className="font-medium text-[#0097b2] mb-2">
                          Support
                        </h4>
                        <p className="text-sm text-gray-700">
                          Foster a supportive learning environment
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="md:w-1/2">
                    <img
                      src="./images/sss-mission.png"
                      alt="Students learning"
                      className="w-full h-auto rounded-lg shadow-md object-cover"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="p-8 sm:p-10 lg:p-12">
                <div className="flex flex-col md:flex-row items-center gap-8">
                  <div className="md:w-1/2 order-2 md:order-1">
                    <img
                      src="./images/sss-vission.png"
                      alt="Future leaders"
                      className="w-full h-auto rounded-lg shadow-md object-cover"
                    />
                  </div>
                  <div className="md:w-1/2 order-1 md:order-2">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6">
                      Shaping <span className="text-[#0097b2]">Tomorrow's</span>{" "}
                      Leaders
                    </h3>
                    <p className="text-lg text-gray-600 mb-6">
                      We envision becoming the most trusted name in education,
                      recognized for our innovative teaching methods,
                      student-centric approach, and consistent record of
                      producing top performers in competitive exams.
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="bg-[#0097b2]/10 p-4 rounded-lg">
                        <h4 className="font-medium text-[#0097b2] mb-2">
                          Innovation
                        </h4>
                        <p className="text-sm text-gray-700">
                          Integrate cutting-edge technology in education
                        </p>
                      </div>
                      <div className="bg-[#0097b2]/10 p-4 rounded-lg">
                        <h4 className="font-medium text-[#0097b2] mb-2">
                          Growth
                        </h4>
                        <p className="text-sm text-gray-700">
                          Expand our reach to serve more students
                        </p>
                      </div>
                      <div className="bg-[#0097b2]/10 p-4 rounded-lg col-span-1 sm:col-span-2">
                        <h4 className="font-medium text-[#0097b2] mb-2">
                          Excellence
                        </h4>
                        <p className="text-sm text-gray-700">
                          Set new benchmarks in educational excellence
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className=" py-8 px-4 sm:py-12 sm:px-6 lg:px-8">
            <div className=" mx-auto">
              {/* Header Section */}
              <div className="text-center mb-4 sm:mb-6">
                <div className="inline-flex items-center gap-2 bg-white/10 px-3 py-1.5 rounded-full mb-4 sm:mb-6">
                  <GraduationCap className="h-4 w-4 sm:h-5 sm:w-5 text-[#0097b2]" />
                  <span className="text-[#0097b2] font-semibold text-sm sm:text-base">
                    From Our Founder
                  </span>
                </div>
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#0097b2] mb-4">
                  Founder’s Note
                </h1>
                <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                  A message from Saumya Rai, the heart and vision behind SSS
                  Achievers.
                </p>
              </div>
              {/* Content Section */}
              <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-4 lg:p-6 mx-2 sm:mx-4">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-start">
                  {/* Founder’s Image and Details */}
                  <div className="flex flex-col items-center lg:items-start">
                    <div className="relative w-full h-[16rem] sm:h-[20rem] md:h-[34rem] rounded-lg overflow-hidden mb-4 sm:mb-6">
                      <img
                        src="../images/founder.webp"
                        alt="Saumya Rai, Founder"
                        className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                      />
                    </div>
                    <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-1">
                      Saumya Rai
                    </h3>
                    <p className="text-sm sm:text-base text-[#0097b2] font-medium mb-1">
                      Founder, SSS Achievers
                    </p>
                    <p className="text-xs sm:text-sm text-gray-600">
                      BA LLB, Education Leadership
                    </p>
                  </div>

                  {/* Founder’s Note */}
                  <div>
                    <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
                      Hello and welcome to SSS Achievers.
                    </p>
                    <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
                      I started this coaching institute with one main goal—to
                      help students get the right guidance and support they need
                      to succeed in their studies and career. Being a student
                      myself once, I understand how important it is to have good
                      teachers and the right direction.
                    </p>
                    <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
                      At SSS Achievers, we work hard to make learning easy and
                      interesting for every student. Whether you are in school
                      or college, our aim is to help you build a strong
                      foundation and grow with confidence.
                    </p>
                    <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
                      This is not just a coaching center—it’s a place where we
                      believe in your dreams and help you achieve them.
                    </p>
                    <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
                      Thank you for being a part of this journey.
                    </p>
                    <p className="text-sm sm:text-base md:text-lg text-gray-700 font-semibold leading-relaxed">
                      With best wishes,
                      <br />
                      Saumya Rai
                      <br />
                      Founder, SSS Achievers
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <div className="text-4xl font-bold text-[#0097b2]">35+</div>
              <div className="mt-2 text-sm font-medium text-gray-500">
                Qualified Educators
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <div className="text-4xl font-bold text-[#0097b2]">340+</div>
              <div className="mt-2 text-sm font-medium text-gray-500">
                Students Empowered
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <div className="text-4xl font-bold text-[#0097b2]">95%</div>
              <div className="mt-2 text-sm font-medium text-gray-500">
                Success Rate
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md text-center">
              <div className="text-4xl font-bold text-[#0097b2]">18+</div>
              <div className="mt-2 text-sm font-medium text-gray-500">
                Courses and Batches
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
